import { SET_CONNECT_MAPS_STATE } from '../actionTypes'
// import moment from 'moment'
// import _ from 'lodash'

const initialState = []

export default (state=initialState,  payload) => {
    switch(payload.type) {

    case SET_CONNECT_MAPS_STATE:
        return payload.connectMapsData || null
    
    default:
        return state
    }
}